import React, { useEffect, useState } from 'react'
import { TopUsersData } from '../../../services'
import { Users, Trophy, Mail, Phone } from 'lucide-react'

function TopUsers() {
  const [topUsers, setTopUsers] = useState([])
  const [loading, setLoading] = useState(true)

  const fetchTopUsers = async () => {
    try {
      setLoading(true)
      const res = await TopUsersData()
      setTopUsers(res)
    } catch (error) {
      console.error('Error fetching activity logs:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchTopUsers()
  }, [])

  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-md p-6 mb-6">
        <div className="animate-pulse">
          <div className="h-6 bg-gray-200 rounded w-1/3 mb-4"></div>
          <div className="space-y-3">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="h-16 bg-gray-200 rounded"></div>
            ))}
          </div>
        </div>
      </div>
    )
  }

  const medalColors = [
    { bg: 'bg-yellow-50', text: 'text-yellow-600', border: 'border-yellow-200' },
    { bg: 'bg-gray-50', text: 'text-gray-600', border: 'border-gray-200' },
    { bg: 'bg-orange-50', text: 'text-orange-600', border: 'border-orange-200' }
  ]

  return (
    <div className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 p-6 mb-6 border border-gray-100">
      <div className="flex items-center mb-6">
        <div className="bg-gradient-to-r from-amber-500 to-orange-500 p-3 rounded-lg mr-4">
          <Trophy className="w-6 h-6 text-white" />
        </div>
        <div>
          <h2 className="text-xl font-bold text-gray-800">Top Users</h2>
          <p className="text-sm text-gray-500">Most active users on your platform</p>
        </div>
      </div>

      {topUsers.length === 0 ? (
        <div className="text-center py-12">
          <div className="bg-gray-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
            <Users className="w-8 h-8 text-gray-400" />
          </div>
          <p className="text-gray-500">No user activity found</p>
        </div>
      ) : (
        <div className="space-y-3">
          {topUsers.map((item, index) => {
            const isTopThree = index < 3
            const colors = isTopThree ? medalColors[index] : { bg: 'bg-white', text: 'text-gray-700', border: 'border-gray-200' }
            
            return (
              <div
                key={index}
                className={`${colors.bg} border ${colors.border} rounded-lg p-4 hover:shadow-md transition-all duration-200`}
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4 flex-1">
                    <div className={`${colors.bg} border-2 ${colors.border} rounded-full w-10 h-10 flex items-center justify-center flex-shrink-0`}>
                      <span className={`text-lg font-bold ${colors.text}`}>#{index + 1}</span>
                    </div>
                    
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center space-x-2 mb-1">
                        <Phone className="w-4 h-4 text-gray-400" />
                        <span className="text-sm font-medium text-gray-800 truncate">
                          {item.user__mobile || 'N/A'}
                        </span>
                      </div>
                      <div className="flex items-center space-x-2">
                        <Mail className="w-4 h-4 text-gray-400" />
                        <span className="text-xs text-gray-600 truncate">
                          {item.user__id || 'N/A'}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="flex-shrink-0 ml-4">
                    <div className={`${colors.text} text-right`}>
                      <div className="text-2xl font-bold">{item.total?.toLocaleString() || 0}</div>
                      <div className="text-xs">activities</div>
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      )}

      {topUsers.length > 0 && (
        <div className="mt-6 pt-4 border-t border-gray-200">
          <div className="text-sm text-gray-500 text-center">
            Showing top {topUsers.length} most active users
          </div>
        </div>
      )}
    </div>
  )
}

export default TopUsers